import { render, staticRenderFns } from "./DashboardAgendamentos.vue?vue&type=template&id=e6f2c968&scoped=true"
import script from "./DashboardAgendamentos.vue?vue&type=script&lang=ts"
export * from "./DashboardAgendamentos.vue?vue&type=script&lang=ts"
import style0 from "./DashboardAgendamentos.vue?vue&type=style&index=0&id=e6f2c968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f2c968",
  null
  
)

export default component.exports